import React, { Component } from 'react'
import _ from 'lodash'
import CSSModules from 'react-css-modules'
import { branch, renderNothing } from 'recompose'

import SpecItem from 'components/custom/SpecItem/index'

import styles from './styles.scss'
import { FILTER_MODIFIED, FILTER_ALL } from 'containers/Project/Specifications/constants'

class FeatureSpec extends Component {
  renderItems() {
    const {
      moduleData,
      isModifiedPage,
      curFilter,
    } = this.props

    const featureData = moduleData['feature']

    if (!featureData || !featureData.modifiedValues) return []

    return featureData.modifiedValues.map((data, index) => {
      if (curFilter !== FILTER_ALL && curFilter !== FILTER_MODIFIED) return

      return (
        <SpecItem
          key={index}
          label={data.value}
          initValues=''
          modifiedValues=''
          curFilter={curFilter}
          isModifiedPage={isModifiedPage}
          curStatus={FILTER_MODIFIED}
        />
      )
    })
    // filter null values
    .filter(val => val)
  }

  render() {
    const {
      ModuleHeader,
    } = this.props
    const items = this.renderItems()
    const Header = branch(
      () => items.length <= 0,
      renderNothing
    )(ModuleHeader)

    return (
      <div>
        <Header />
        <div styleName='specItemFeature'>
          { items }
        </div>
      </div>
    )
  }
}

export default CSSModules(FeatureSpec, styles)
